import { ILanguages } from '../../handlers/TranslationsHandler';

export interface ITileSummary {
  name: string;
  category: TileCategoriesEnum;
  title: ILanguages;
  description: ILanguages;
  autofillTile?: boolean;
  premiumTile?: boolean;
  isLarge?: boolean;
}

export enum TileCategoriesEnum {
  Sonstiges = 'Sonstiges',
  Infrastruktur = 'Infrastruktur',
  SmartLighting = 'SmartLighting',
  Mobilität = 'Mobilität',
  Energie = 'Energie',
  Umwelt = 'Umwelt',
  Finanzen = 'Finanzen'
}

export const TILES: ITileSummary[] = [
  {
    name: 'financial-placeholder-0',
    title: {
      EN: 'Budget balance development',
      DE: 'Entwicklung Haushaltsausgleich'
    },
    description: {
      EN: 'Ordinary result with reserves from previous years',
      DE: 'Ordentliches Ergebnis mit Rücklagen der letzten Jahre'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-1',
    title: {
      EN: 'Budgetary balance Intercommunal',
      DE: 'Haushaltsausgleich Interkommunal'
    },
    description: {
      EN:
        'Comparative presentation of the budget balance of different communities',
      DE:
        'Vergleichende Darstellung des Haushaltsausgleich verschiedener Kommunen'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-2',
    title: {
      EN: 'Budget balance comparison',
      DE: 'Haushaltsausgleich Vergleich'
    },
    description: {
      EN: 'Development of the budget balance over the past years',
      DE: 'Entwicklung des Haushaltsausgleich über die letzten Jahre'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-3',
    title: { EN: 'Budget balance', DE: 'Haushaltsausgleich' },
    description: {
      EN: 'Breakdown of the budget balance',
      DE: 'Aufschlüsselung des Haushaltsausgleichs'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-4',
    title: { EN: 'Planned/actual deviation', DE: 'Plan-Ist Abweichung' },
    description: {
      EN:
        ' Presentation of the estimated ordinary result before appropriation of reserves',
      DE:
        'Darstellung des geschätztes ordentlichen Ergebnis vor Verwendung von Rücklagen'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-5',
    title: { EN: 'Ordinary expenses', DE: 'Ordentliche Aufwendungen' },
    description: {
      EN: 'Tabular breakdown of ordinary expenses',
      DE: 'Tabellarische Aufschlüsselung der ordentlichen Aufwendungen'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-6',
    title: { EN: 'Ordinary income', DE: 'Ordentliche Erträge' },
    description: {
      EN: 'Tabular breakdown of ordinary income',
      DE: 'Tabellarische Aufschlüsselung der ordentlichen Erträge'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-7',
    title: { EN: 'Financial overview', DE: 'Finanzüberblick' },
    description: {
      EN: 'Overview of municipal finances',
      DE: 'Überblick der kommunalen Finanzen'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-8',
    title: {
      EN: 'Development of the assessment rate for property tax B',
      DE: 'Hebesatzentwicklung Grundsteuer B'
    },
    description: {
      EN: 'Development of average assessment rates for property tax B',
      DE: 'Entwicklung durchschnittlicher Hebesätze der Grundsteuer B'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'financial-placeholder-9',
    title: {
      EN: 'Expected level of reserves',
      DE: 'Voraussicht. Stand der Rücklagen'
    },
    description: {
      EN: 'Comparison of the development of the amount of ordinary reserves',
      DE: 'Vergleich der Entwicklung der Höhe der ordentlichen Rücklagen'
    },
    category: TileCategoriesEnum.Finanzen,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: '7-day-incidence',
    title: { EN: '7-day incidence', DE: '7-Tage Inzidenz' },
    description: {
      EN: 'The local 7-day incidence in a graph',
      DE: 'Die lokale 7-Tage Inzidenz in einer Darstellung als Graph'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'amount-of-waste',
    title: { DE: 'Abfallmenge', EN: 'Amount of Waste' },
    description: {
      DE:
        'Die Menge des Gesamtabfalls in Gegenüberstellung zur Menge recycleten Abfalls',
      EN: 'The amount of total waste compared to the amount of recycled waste'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'astroclock',
    title: { DE: 'Astrouhr', EN: 'Astro Clock' },
    description: {
      DE:
        'Die geplante Einschaltzeit der Straßenbeleuchtung abhängig vom Sonnenauf-/untergang',
      EN:
        'The planned activation time of street lighting depending on sunrise/sunset'
    },
    category: TileCategoriesEnum.SmartLighting,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'brightness-control',
    title: { DE: 'Helligkeitssteuerung', EN: 'Brightness Control' },
    description: {
      DE:
        'Eine interaktive Steuerungsmöglichkeit für die Straßenbeleuchtung abhängig vom Sonnenstand',
      EN:
        'An interactive control possibility for street lighting depending on the position of the sun'
    },
    category: TileCategoriesEnum.SmartLighting,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'charging-stations',
    title: { DE: 'Ladestationen', EN: 'Charging Stations' },
    description: {
      DE: 'Die Belegung einer Ladesäule bzw. des zugehörigen Parkplatzes',
      EN: 'The occupancy of a charging station or the associated parking space'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'city-info',
    title: { DE: 'Stadtinformationen', EN: 'City Information' },
    description: {
      DE:
        'Zeigt die wesentlichen Informationen zur Stadt an, wie beispielsweise Einwohnerzahl, Fläche, etc.',
      EN:
        'Displays essential information about the city, such as population, area, etc.'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: false,
    autofillTile: true
  },
  {
    name: 'citizen-participation',
    title: { DE: 'Bürgerbeteiligung', EN: 'Citizen Participation' },
    description: {
      DE: 'Bürgerinteraktion und -beteiligung an neuen Smart City Use-Cases',
      EN: 'Citizen interaction and participation in new Smart City use cases'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'co2-savings-1',
    title: { DE: 'CO2 Einsparungen', EN: 'CO2 Savings' },
    description: {
      DE: 'Die durch erneuerbare Energien gesparten CO2-Emissionen',
      EN: 'CO2 emissions saved through renewable energy'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'co2-savings-2',
    title: { DE: 'CO2 Einsparung', EN: 'CO2 Savings' },
    description: {
      DE: 'Auf verschiedene Segmente aufgeteilte CO2-Emissionen',
      EN: 'CO2 emissions divided into various segments'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'corona-inform',
    title: { DE: 'Corona-Informationen', EN: 'Corona Information' },
    description: {
      DE:
        'Informationstexte zur Information der Bürger am Beispiel von COVID-19-Infos',
      EN:
        'Information texts for informing citizens using the example of COVID-19 information'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'covid-19-situation',
    title: { DE: 'COVID-19-Situation', EN: 'COVID-19 Situation' },
    description: {
      DE:
        'Zeigt auf übersichtliche Weise die wichtigsten aktuellen Kennzahlen zum Corona-Virus',
      EN:
        'Displays the most important current key figures on the coronavirus in a clear manner'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: true,
    autofillTile: false
  },

  {
    name: 'crossfleet',
    title: { DE: 'Crossfleet', EN: 'Crossfleet' },
    description: {
      DE:
        'Eine Carsharing-Flotte in der Übersicht, mit Telemetriedaten der Fahrzeuge',
      EN:
        'An overview of a car-sharing fleet, with telemetry data of the vehicles'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'current-weather',
    title: { DE: 'Aktuelles Wetter', EN: 'Current Weather' },
    description: {
      DE:
        'Die aktuelle Wetterlage - einfach und ohne zusätzliche Sensorik abrufbar',
      EN:
        'The current weather - simple and accessible without additional sensors'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: true
  },
  {
    name: 'customer-requests',
    title: { DE: 'Serviceaufträge', EN: 'Service Requests' },
    description: {
      DE:
        'Bürgerinteraktion am Beispiel eines Meldeportals für Serviceaufträge',
      EN:
        'Citizen interaction as exemplified by a reporting portal for service requests'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'data-traffic-cameras',
    title: { DE: 'Verkehrskameras', EN: 'Traffic Cameras' },
    description: {
      DE:
        'Verkehrszählwerte aus Kameras, gruppiert und pro Messpunkt dargestellt',
      EN:
        'Traffic count values from cameras, grouped and represented per measurement point'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    isLarge: true,
    autofillTile: false
  },
  {
    name: 'deceased',
    title: { DE: 'Verstorbene', EN: 'Deceased' },
    description: {
      DE: 'Statistische Daten zu an COVID-19 verstorbenen Personen',
      EN: 'Statistical data on individuals deceased due to COVID-19'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'digital-city-tour',
    title: { DE: 'Digitaler Stadtrundgang', EN: 'Digital City Tour' },
    description: {
      DE:
        'Eine typische Kachel mit einem Bild und Absprung in eine Fachanwendung',
      EN: 'A typical tile with an image and a jump to a specialized application'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'digital-fields-of-action',
    title: { DE: 'Digitale Handlungsfelder', EN: 'Digital Fields of Action' },
    description: {
      DE:
        'Die verschiedenen Kacheln des Cockpits jeweils in Segmenten ausgewertet',
      EN: 'The various tiles of the cockpit each evaluated in segments'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'domain-specific-language',
    title: { DE: 'Domänenspezifische Sprache', EN: 'Domain-Specific Language' },
    description: {
      DE: 'Smart Home bzw. Smart Building in der Übersicht',
      EN: 'Overview of Smart Home or Smart Building'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'energy',
    title: { DE: 'Energie', EN: 'Energy' },
    description: {
      DE: 'Relevante Kennwerte zur Energieversorgung und -Speicherung',
      EN: 'Relevant parameters for energy supply and storage'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'energy-history',
    title: { DE: 'Energie Historie', EN: 'Energy History' },
    description: {
      DE: 'Parameter der Energiekennwerte im zeitlichen Verlauf',
      EN: 'Parameters of energy characteristics over time'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'energy-mix-2020',
    title: { DE: 'Energiemix', EN: 'Energy Mix' },
    description: {
      DE: 'Städtische Liegenschaften und deren Energieverbrauch',
      EN: 'Urban properties and their energy consumption'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'energy-savings',
    title: { DE: 'Energieeinsparung', EN: 'Energy Savings' },
    description: {
      DE:
        'Anschauliche Darstellung von verbrauchter Energie zu eingespartem CO2',
      EN: 'Clear representation of consumed energy to saved CO2'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'environment-1',
    title: { DE: 'Umwelt', EN: 'Environment' },
    description: {
      DE: 'Umwelt-Messwerte mit Auswahl nach Sensorik',
      EN: 'Environmental measurement values with selection by sensor technology'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'environment-2',
    title: { DE: 'Umwelt (groß)', EN: 'Environment (large)' },
    description: {
      DE: 'Umwelt-Messwerte mit grafischem Verlauf und Auswahl pro Messwert',
      EN:
        'Environmental measurement values with graphical trend and selection per measured value'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    isLarge: true,
    autofillTile: false
  },
  {
    name: 'environment-3',
    title: { DE: 'Umwelt', EN: 'Environment' },
    description: {
      DE: 'Einfache Darstellung der Umwelt-Messwerte',
      EN: 'Simple representation of environmental measurement values'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'environment-4',
    title: { DE: 'Umwelt', EN: 'Environment' },
    description: {
      DE: 'Wetterdaten in einfacher Darstellung',
      EN: 'Weather data in simple representation'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'environment-5',
    title: { DE: 'Umwelt', EN: 'Environment' },
    description: {
      DE: 'Variante der Umweltkachel',
      EN: 'Variant of the environmental tile'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'environment-6',
    title: { DE: 'Umwelt', EN: 'Environment' },
    description: {
      DE: 'Umwelt-Messwerte in Buttons dargestellt',
      EN: 'Environmental measurements displayed in buttons'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'events',
    title: { DE: 'Veranstaltungen', EN: 'Events' },
    description: {
      DE: 'Die nächsten lokalen Veranstaltungen in der Darstellung als Liste',
      EN: 'The upcoming local events presented as a list'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'infected',
    title: { DE: 'Infizierte', EN: 'Infected' },
    description: {
      DE:
        'Kachel aus dem COVID-19 Kontext, Darstellung aktuell lokaler infizierter Personen',
      EN:
        'Tile from the COVID-19 context, representation of currently local infected individuals'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'place-utilization',
    title: { DE: 'Bebaute Fläche', EN: 'Built-up Area' },
    description: {
      DE: 'Die bebaute Fläche einer Kommune der Grünfläche gegenübergestellt',
      EN: 'Comparison of the built-up area of a municipality to the green area'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'mobility-station',
    title: { DE: 'Mobilitätsstation', EN: 'Mobility Station' },
    description: {
      DE: 'Ein Fahrzeug einer Mobilitätsstation inkl. Verfügbarkeitsanzeige',
      EN: 'A vehicle from a mobility station including availability display'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'modal-split',
    title: { DE: 'Verkehrsmittel', EN: 'Modes of Transport' },
    description: {
      DE: 'Der Modal-Split aller Verkehrsteilnehmer',
      EN: 'The modal split of all road users'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'my-consumption',
    title: { DE: 'Mein Verbrauch', EN: 'My Consumption' },
    description: {
      DE: 'Durch Smart Meter ermittelter Verbrauch von Strom, Gas und Wasser',
      EN: 'Consumption of electricity, gas, and water determined by smart meter'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'network-of-neighborhoods',
    title: { DE: 'Quartiersnetzwerk', EN: 'Neighborhood Network' },
    description: {
      DE:
        'Ein Beispiel der möglichen Bürgerbeteiligung durch ein Quartiersnetzwerk',
      EN:
        'An example of possible citizen participation through a neighborhood network'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'noise-measurement-history',
    title: { DE: 'Geräuschmessungsverlauf', EN: 'Noise Measurement History' },
    description: {
      DE: 'Verlauf und Mittelwerte von Sensoren gemessener Geräusche',
      EN: 'History and averages of noise measured by sensors'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'noise-pollution-1',
    title: { DE: 'Lärmbelastung', EN: 'Noise Pollution' },
    description: {
      DE: 'Höchste, niedrigste und letzte lokale Lärmmessung',
      EN: 'Highest, lowest, and last local noise measurement'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'noise-pollution-2',
    title: { DE: 'Luftqualität', EN: 'Air Quality' },
    description: {
      DE: 'Die Luftqualität in einem Graphen dargestellt',
      EN: 'Air quality represented in a graph'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'noise-pollution-3',
    title: { DE: 'Lärmmessung', EN: 'Noise Measurement' },
    description: {
      DE: 'Lärmmessung mit zeitlichem Verlauf',
      EN: 'Noise measurement with temporal progression'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    isLarge: true,
    autofillTile: false
  },
  {
    name: 'open-data-portal',
    title: { DE: 'Open-Data-Portal', EN: 'Open Data Portal' },
    description: {
      DE: 'Anzeige der Datensätze in einem Open-Data-Portal',
      EN: 'Display of data sets in an open data portal'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'overview',
    title: { DE: 'Übersicht', EN: 'Overview' },
    description: {
      DE: 'Eine Übersicht der verschiedenen Bereiche in einer Ampeldarstellung',
      EN: 'An overview of the different areas in a traffic light representation'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'own-supply-of-energy',
    title: { DE: 'Eigenversorgung Energie', EN: 'Self-Supply of Energy' },
    description: {
      DE: 'Die Eigenversorgung mit Energie innerhalb der letzten sieben Tage',
      EN: 'Self-supply of energy within the last seven days'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'parking',
    title: { DE: 'Parken', EN: 'Parking' },
    description: {
      DE: 'Ein oder mehrere Parkplätze und deren aktuelle Belegung',
      EN: 'One or more parking spaces and their current occupancy'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'parking-spaces',
    title: { DE: 'Parkhäuser', EN: 'Parking Garages' },
    description: {
      DE: 'Übersichtliche Darstellung der aktuellen Belegung der Parkhäuser',
      EN: 'Clear representation of the current occupancy of parking garages'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'place-utilization',
    title: { DE: 'Flächennutzung', EN: 'Land Use' },
    description: {
      DE: 'Die bebaute Fläche einer Kommune der Grünfläche gegenübergestellt',
      EN: 'The built-up area of a municipality compared to the green space'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'presence-dependent-lc',
    title: {
      DE: 'Präsenzabhängige Lichtsteuerung',
      EN: 'Presence-Dependent Light Control'
    },
    description: {
      DE: 'Durch Fußgänger aktivierte präsenzabhängige Straßenbeleuchtung',
      EN: 'Pedestrian-activated presence-dependent street lighting'
    },
    category: TileCategoriesEnum.SmartLighting,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'public-transport',
    title: { DE: 'Öffentlicher Verkehr', EN: 'Public Transport' },
    description: {
      DE: 'Abfahrten zweier Stationen im öffentlichen Nahverkehr',
      EN: 'Departures of two stations in public local transport'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'real-time-noise-measurements',
    title: {
      DE: 'Echtzeit-Rauschmessungen',
      EN: 'Real-Time Noise Measurements'
    },
    description: {
      DE: 'Darstellung der Rauschmessungen professioneller Geräusch-Sensorik',
      EN: 'Display of noise measurements from professional noise sensors'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'renewable-energy',
    title: { DE: 'Erneuerbare Energien', EN: 'Renewable Energies' },
    description: {
      DE: 'Anteil erneuerbarer Energien am Gesamt-Energiemix',
      EN: 'Share of renewable energies in the total energy mix'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'sensor-manager',
    title: { DE: 'Sensormanager', EN: 'Sensor Manager' },
    description: {
      DE: 'Der Status verschiedener Sensoren und Geräte im Überblick',
      EN: 'The status of various sensors and devices at a glance'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'sensor-station-a',
    title: { DE: 'Sensor Station A', EN: 'Sensor Station A' },
    description: {
      DE: 'Der Frequenzbereich einer Geräusch-Messstation',
      EN: 'The frequency range of a noise measurement station'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'smart-charging',
    title: { DE: 'Smartes Laden', EN: 'Smart Charging' },
    description: {
      DE: 'Ladesäulen einer Kommune in der übersichtlichen Darstellung',
      EN: 'Charging stations of a municipality in a clear representation'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'smart-home',
    title: { DE: 'Intelligentes Zuhause', EN: 'Smart Home' },
    description: {
      DE: 'Smart Home Übersicht und Anzahl verbundener Geräte',
      EN: 'Smart home overview and number of connected devices'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'smart-irrigation',
    title: { DE: 'Smarte Bewässerung', EN: 'Smart Irrigation' },
    description: {
      DE: 'Intelligente Bewässerung und Darstellung der Bodenfeuchtigkeit',
      EN: 'Intelligent irrigation and representation of soil moisture'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'smart-lighting-1',
    title: { DE: 'Smart Lighting 1', EN: 'Smart Lighting 1' },
    description: {
      DE: 'Intelligente Straßenbeleuchtung mit Verbrauchsanzeige',
      EN: 'Intelligent street lighting with consumption display'
    },
    category: TileCategoriesEnum.SmartLighting,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'smart-lighting-2',
    title: { DE: 'Smart Lighting 2', EN: 'Smart Lighting 2' },
    description: {
      DE: 'Steuerbare Straßenbeleuchtung mit Dimmer-Einstellung',
      EN: 'Controllable street lighting with dimmer setting'
    },
    category: TileCategoriesEnum.SmartLighting,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'smart-parking',
    title: { DE: 'Smart Parking', EN: 'Smart Parking' },
    description: {
      DE: 'Verschiedene Parkplätze und Sensorik zum Thema Smart Parking',
      EN: 'Various parking lots and sensor technology related to Smart Parking'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'smart-wifi',
    title: { DE: 'Smart WiFi', EN: 'Smart WiFi' },
    description: {
      DE: 'Öffentliches WLAN-Netz mit Nutzungsanzeige und Statusinformationen',
      EN: 'Public WiFi network with usage display and status information'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'solar-energy',
    title: { DE: 'Solarenergie', EN: 'Solar Energy' },
    description: {
      DE: 'Die aktuelle generierte Solarenergie und weitere Informationen',
      EN: 'The current generated solar energy and further information'
    },
    category: TileCategoriesEnum.Energie,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'testing-waste-container',
    title: { DE: 'Abfallbehälter', EN: 'Waste Containers' },
    description: {
      DE: 'Übersicht und Aufteilung der anfallenden Abfallmengen',
      EN: 'Overview and division of the accumulated waste quantities'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'traffic-1',
    title: {
      DE: 'Ein- und Ausgangsverkehr',
      EN: 'Inbound and Outbound Traffic'
    },
    description: {
      DE: 'Ein- und Ausgangsverkehr gegenübergestellt nach Zeit',
      EN: 'Inbound and outbound traffic compared over time'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'traffic-2',
    title: { DE: 'Verkehr', EN: 'Traffic' },
    description: {
      DE: 'Die aktuelle Verkehrssituation in der Übersicht',
      EN: 'The current traffic situation at a glance'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'traffic-dependent-lc',
    title: {
      DE: 'Verkehrsabhängige Lichtregelung',
      EN: 'Traffic-Dependent Light Control'
    },
    description: {
      DE: 'Intelligente Straßenbeleuchtung abhängig vom Verkehr',
      EN: 'Intelligent street lighting depending on traffic'
    },
    category: TileCategoriesEnum.SmartLighting,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'traffic-information',
    title: { DE: 'Verkehrsinformationen', EN: 'Traffic Information' },
    description: {
      DE: 'Baustelleninformationen und erwartete Zeiträume',
      EN: 'Construction site information and expected periods'
    },
    category: TileCategoriesEnum.Mobilität,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'upcoming-projects-1',
    title: { DE: 'Kommende Projekte 1', EN: 'Upcoming Projects 1' },
    description: {
      DE: 'Spannende, neue Projekte werden demnächst hier zu finden sein',
      EN: 'Exciting, new projects will be found here soon'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: false,
    autofillTile: true
  },
  {
    name: 'urban-trash-can',
    title: { DE: 'Städtische Mülleimer', EN: 'Urban Trash Cans' },
    description: {
      DE: 'Füllstand der öffentlichen Mülleimer',
      EN: 'Fill level of public trash cans'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: false,
    autofillTile: false
  },
  {
    name: 'vaccinations',
    title: { DE: 'Impfungen', EN: 'Vaccinations' },
    description: {
      DE: 'Anzahl der gegen COVID-19 geimpften Personen im zeitlichen Verlauf',
      EN: 'Number of persons vaccinated against COVID-19 over time'
    },
    category: TileCategoriesEnum.Sonstiges,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'water-consumption',
    title: { DE: 'Wasserverbrauch', EN: 'Water Consumption' },
    description: {
      DE:
        'Der Wasserverbrauch städtischer Liegenschaften anschaulich dargestellt',
      EN: 'The water consumption of municipal properties illustrated'
    },
    category: TileCategoriesEnum.Infrastruktur,
    premiumTile: true,
    autofillTile: false
  },
  {
    name: 'water-levels',
    title: { DE: 'Wasserstände', EN: 'Water Levels' },
    description: {
      DE:
        'Aktiver Hochwasserschutz beginnt auch mit der Erfassung der Wasserstände, hier in einer Kachel dargestellt',
      EN:
        'Active flood protection also starts with recording the water levels, shown here in a tile'
    },
    category: TileCategoriesEnum.Umwelt,
    premiumTile: false,
    autofillTile: false
  }
];
